import React, { useRef } from 'react';
import { createPortal } from 'react-dom';
import { useClickOutside } from 'react-haiku';

import { Title } from 'components/Misc/Typography';
import Icon from 'components/Misc/Icon';

const Modal = ({ title, visible, handleModal, children }) => {
	// Store container's ref
	const ref = useRef(null);

	// Use outside handler
	// TODO: Fix issue with datepicker
	// useClickOutside(ref, handleModal);

	// Do not render modal if it's not visible
	if (!visible) return null;

	return createPortal(
		<div className="fixed top-0 right-0 bottom-0 left-0 z-30 sm:p-4 flex justify-center items-center bg-[rgba(0,0,0,0.15)] backdrop-blur-sm">
			<div ref={ref} className="w-full max-w-screen-sm max-h-full flex flex-col bg-white dark:bg-neutral-800 sm:rounded-lg">
				<div className="pt-4 px-4 flex justify-between">
					<Title
						title={title}
						className="text-lg"
					/>

					<Icon
						icon="close"
						className="text-red-500 text-xl cursor-pointer"
						onClick={handleModal}
					/>
				</div>

				<div className="flex-grow flex-shrink basis-auto p-4 overflow-x-hidden overflow-y-auto">
					{children}
				</div>
			</div>
		</div>
		, document.body);
};

export default Modal;